import { render } from "./NPForm.vue?vue&type=template&id=4c639c43"
import script from "./NPForm.vue?vue&type=script&lang=js"
export * from "./NPForm.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__